import { useState } from 'react';
import { hotRanking } from '@/mocks/home';

const TABS = ['实时总榜', '上升最快', '争议指数'];

export default function HotRanking() {
  const [tab, setTab] = useState('实时总榜');

  const list =
    tab === '上升最快'
      ? hotRanking.filter((i) => i.trend === 'up')
      : tab === '争议指数'
        ? [...hotRanking].reverse().slice(0, 8)
        : hotRanking;

  return (
    <section id="hot" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <div className="mb-6 flex flex-wrap items-center justify-between gap-3 border-b-2 border-foreground-950 pb-3">
              <div className="flex items-end gap-3">
                <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">热搜榜</h3>
                <span className="mb-1 text-xs text-foreground-500">数据每小时刷新一次</span>
              </div>
              <div className="flex items-center gap-1 rounded-full bg-background-50 p-1">
                {TABS.map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => setTab(t)}
                    className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                      tab === t ? 'bg-foreground-950 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                    }`}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>

            <ul className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {list.map((item, idx) => (
                <li key={item.id} className="border-b border-background-200 last:border-b-0">
                  <a href="#today" className="group flex cursor-pointer items-center gap-4 px-4 py-3.5 transition-colors hover:bg-primary-50 md:px-5">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
                        idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                        {item.title}
                      </div>
                      <div className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-background-200">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                          style={{ width: `${100 - idx * 8}%` }}
                        />
                      </div>
                    </div>
                    <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-500">
                      <i
                        className={
                          item.trend === 'up'
                            ? 'ri-arrow-up-line text-primary-600'
                            : item.trend === 'down'
                              ? 'ri-arrow-down-line text-foreground-400'
                              : item.trend === 'new'
                                ? 'ri-add-line text-accent-700'
                                : 'ri-subtract-line text-foreground-400'
                        }
                      />
                      {item.heat}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="mb-6 border-b-2 border-foreground-950 pb-3">
              <h3 className="font-heading text-2xl font-black text-foreground-950">瓜友正在说</h3>
            </div>
            <div className="space-y-3">
              {[
                { user: '前排不睡觉', text: '这个时间线我看了三遍，是真的能对上。', tag: '热评' },
                { user: '理性吃瓜', text: '证据还没鉴定，先别急着站队吧。', tag: '高赞' },
                { user: '搬瓜小分队', text: '品牌方连夜撤物料，这波操作太说明问题了。', tag: '新' },
                { user: '瓜田守夜人', text: '凌晨那条首发我全程跟了，速度真的炸裂。', tag: '热度' },
              ].map((c) => (
                <div key={c.user} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <div className="mb-2 flex items-center gap-2">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-200 text-xs font-bold text-secondary-900">
                      {c.user.slice(0, 1)}
                    </span>
                    <span className="text-sm font-medium text-foreground-900">{c.user}</span>
                    <span className="ml-auto rounded-md bg-accent-100 px-2 py-0.5 text-xs text-accent-900">{c.tag}</span>
                  </div>
                  <p className="text-sm leading-relaxed text-foreground-600">{c.text}</p>
                </div>
              ))}
              <a
                href="#comment"
                className="flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-chat-3-line" />
                进入完整评论区
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}